<template>
  <div>
    <AdminNav></AdminNav>
    <h1>HELLO, Admin</h1>
    <p>{{ msg }}</p>
    <div class="card" >
      <div class="card-body">
        <div id="v-for-object" class="row" v-if="items">
          <div class="col-md-4" :key="key" v-for="(item, key) in items">
            <div class="statistics">
              <div class="info">
                <div class="icon icon-primary">
                  <i class="now-ui-icons ui-2_chat-round"></i>
                </div>
                <h3 class="info-title">
                  <span>{{item.length}}</span>
                </h3>
                <h6 class="stats-title">{{item.type}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<div v-else>-->
      <!--<p>Loading...</p>-->
    <!--</div>-->
  </div>
</template>

<script>
import axios from 'axios';

import AdminNav from "@/components/AdminNav";
export default {
  name: "Hello",
  components: {
    AdminNav
  },
  data() {
    return {
      msg: "Your users have been busy.",
      items:{},
      auth:null
    };
  },
  created(){
    this.getArticles()
  },
  methods: {
    getArticles: function() {
      var items = ["users","articles","outfits"];
      for(var i = 0; i < items.length; i++){
        this.loopFirebase(items[i])
      }
    },
    loopFirebase: function(item) {
      axios.get(`https://what-did-i-wear-ios.firebaseio.com/${item}.json?shallow=true`)
        .then(response => {
          this.items = {
            ...this.items,
            [item]: {
              'type':item,
              'length':Object.keys(response.data).length
            }
          }
        })
        .catch(error => {
          console.log(error);
        })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

button {
  padding: 10px 20px;
  background: #42b983;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 22px;
  outline: 0;
  cursor: pointer;
}
.card{
    border: 0;
    border-radius: .1875rem;
    display: inline-block;
    position: relative;
    width: 100%;
    margin-bottom: 20px;
    box-shadow: 0 1px 15px 1px rgba(39,39,39,.1);
}
.card .card-body{
      padding: 15px 15px 10px;
}
</style>
